module.exports = __webpack_public_path__ + "static/media/bs.9fc1437a.svg";